export default __webpack_public_path__ + "static/media/_ic_check.e707827a.svg";